var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    class: (_class = {
      'activity-stage': true,
      'mobile-aa-activity-stage': _vm.isMobileAAActivity
    }, _class[_vm.customRootContainerClass] = !!_vm.customRootContainerClass, _class),
    style: _vm.customRootContainerStyles
  }, [_vm.isMobileAAActivity ? _c('article', {
    attrs: {
      "id": "mobile-aa-activity-header"
    }
  }) : _vm._e(), _c('article', {
    style: _vm.customScrollContainerStyles,
    attrs: {
      "id": "scroll-container"
    }
  }, [_vm._t("instructions"), _c('article', {
    staticClass: "content-container",
    style: _vm.customContentContainerStyles
  }, [_vm._t("content")], 2)], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }